import "./sign-out.css";
import signOutIcon from "./sign-out.png";
import {Button} from "react-bootstrap";
import {signOut} from '../user/userSlice';
import {useDispatch} from "react-redux";
import ApiRequest from "../../api/ApiRequest";

export default function SignOutButton() {
  const dispatch = useDispatch();

  return (
    <div className="sign-out">
      <Button onClick={handleClick} className="sign-out-button"><img src={signOutIcon} alt="Выйти" /></Button>
    </div>
  );

  function handleClick() {
    const status = ApiRequest.signOut.signOut();
    if (!status) return;
    dispatch(signOut());
  }
}
